// extracted by mini-css-extract-plugin
export default {"verifiedEmailContainer":"EmailVerificationModal_verifiedEmailContainer__PfCs3","emailLogos":"EmailVerificationModal_emailLogos__BcL30"};